import React , {Component} from 'react';
import FooterViews from '../views/Footer';
class Footer extends Component {
    render() {
        return (
          <FooterViews />
        );
    }
}

export default Footer;
